import "./Tooltip.css";

export default function Tooltip({value}) {
  	return (
        <div className="tooltip tooltip-dark bs-tooltip-auto fade show">
            <div className="tooltip-arrow top"></div>
            <div className="tooltip-inner">{value}</div>
        </div>

	);
}